import React from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";
import debug from "../utils/debug"

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    debug("WATCH","Loader", this.props);
  }
  render() {
    const { isLoader } = this.props;
    const displayLoader = isLoader ? "inline-block" : "none";
    return (
      <div
        style={{
          display: displayLoader,
          position: "fixed",
          width: "100%",
          height: "100%",
          left: 0,
          top: 0,
          opacity: "0.5",
          backgroundColor: "#fff",
          zIndex: 1100,
        }}
      >
        <CircularProgress
          style={{
            position: "absolute",
            top: "50vh",
            left: "50%",
          }}
        />
      </div>
    );
  }
}

Loader.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoader: PropTypes.bool.isRequired,
};

export default Loader;
